"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getSportIconColorsView = void 0;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const constants_1 = require("./constants");
const getSportIconColorsView = (theme) => ({
    [betweb_openapi_axios_1.LayoutTheme.Light]: constants_1.SPORT_ICON_COLORS_VIEW_LIGHT_THEME,
    [betweb_openapi_axios_1.LayoutTheme.Dark]: constants_1.SPORT_ICON_COLORS_VIEW_DARK_THEME,
}[theme]);
exports.getSportIconColorsView = getSportIconColorsView;
//# sourceMappingURL=utils.js.map